import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AccountPortalAuthService } from '../auth.service';
// import { AuthService } from '@sbd-account-portal/app/core/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class EmailPrefilledGuard implements CanMatch
{
    /**
     * Constructor
     */
    constructor(
        private _authService: AccountPortalAuthService,
        private _router: Router
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can match
     *
     * @param route
     * @param segments
     */
    canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        return this._check();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @private
     */
    private _check(): Observable<boolean>
    {
        // Check the authentication status and return an observable of
        // "true" or "false" to allow or prevent the access
        let dat_ = false;
        this._authService.checkIfUserEmailPrefilled().subscribe((emailFilled) =>
          dat_ = emailFilled
        );

        return of(!dat_);
    }
}
